module.exports = "<app-dialogs-header\n  (closeDialog)=\"closeDialog()\"\n  title=\"აღწერის ტექსტი\"\n></app-dialogs-header>\n<p mat-dialog-content class=\"padding-16\">\n  {{ data.description }}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/description-dialog/description-dialog.component.html
// module id = ../../../../../src/app/components/admin/components/shared/petition-details/dialogs/description-dialog/description-dialog.component.html
// module chunks = main